import Image from 'next/image';
import { StyledSortImagesActivity } from './SortImagesActivity.styled';

export default function SortImagesActivity({ activity }) {
  const banner = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
    process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
      ? 'production'
      : 'staging'
  }/games/sortImages/${activity?.data?.folder}/${activity?.data?.banner}`;

  return (
    <StyledSortImagesActivity>
      {banner ? (
        <div className="activity-image">
          <Image
            src={banner}
            alt={activity.name}
            layout="fill"
            objectFit="contain"
          />
        </div>
      ) : null}
    </StyledSortImagesActivity>
  );
}
